import { QRCodeToDataURLOptions, toDataURL } from 'qrcode'
import { useEffect } from 'react'
import { theme } from '../../theme'

const options: QRCodeToDataURLOptions = {
    errorCorrectionLevel: 'H',
    type: 'image/jpeg',
    margin: 1,
    color: {
        dark: theme.colors.primaryGreen,
        light: theme.colors.white,
    },
}

export const useQRCode = (
    text: string,
    setQRCodeUrl: (value: string) => void
) => {
    useEffect(() => {
        if (!text) {
            return
        }

        toDataURL(text, options, (error, url) => {
            if (error) {
                console.error(error)
                return
            }
            setQRCodeUrl(url)
        })
    }, [text])
}
